import { render, staticRenderFns } from "./ProductShopBlock.vue?vue&type=template&id=46969fee&scoped=true&"
import script from "./ProductShopBlock.vue?vue&type=script&lang=js&"
export * from "./ProductShopBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductShopBlock.vue?vue&type=style&index=0&id=46969fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46969fee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
